import { z } from 'zod';

// Video options have to be a tiny module to prevent circular dependencies
const SlideVideoOptionsSchema = z.object({
  loop: z.boolean().nullable().optional(),
  autoPlay: z.boolean().optional(),
});

export type SlideVideoOptions = z.infer<typeof SlideVideoOptionsSchema>;

export { SlideVideoOptionsSchema };
